//#region src/assets/email.png
var email_default = "" + new URL("email-B--1SzuR.png", import.meta.url).href;
//#endregion
export { email_default as default };

//# sourceMappingURL=email.js.map